import React, { useEffect, useState } from 'react';
import { Modal, Button, Upload, Input, message, Select, Typography, Space, Row, Col } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { exportAddon } from '@/apis/addons';

const { TextArea } = Input;

export const ExportAddon = ({ addonId, visible, setVisible}) => {
  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState('');
  const [versions, setVersions] = useState([]);

  useEffect(() => {
    if(visible) {
      const callExportAddon = async () => {
        const contentObj = await exportAddon(addonId);
        if(contentObj) {
          setFileContent(contentObj);
          setFileName(contentObj.name);
          setVersions([contentObj?.version]); 
        }
      }
      callExportAddon();
    }
  }, [addonId, visible]);

  const handleExport = () => {
    if (!fileContent && !fileName) {
      message.error('Please select file first!');
      return;
    }

    const content = JSON.stringify(fileContent, null, 2);
    const exportName = fileName || '';

    const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
    
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `Addon-${exportName}.json`;
    document.body.appendChild(link);
    link.click();
    
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    }, 0);

    message.success('Export addon successfully');
    setVisible(false);
  };

  const clear = () => {
    setFileContent(null);
    setFileName('');
    setVersions([]);
  }

  return (
    <>
      <Modal
        title="Export Add-on"
        visible={visible}
        onOk={handleExport}
        onCancel={() => {setVisible(false); clear()}}
        okText="Export"
        cancelText="Cancel"
        width={800}
        styles={{
          body: {
            height: '60vh',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: 24
          }
        }}
      >
        <Row align="middle" gutter={12}>
          <Col span={2}>
          <label>Name</label>
          </Col>
          <Col span={18}>
            <Input style={{ width: '80%' }} value={fileName}/>
          </Col>
        </Row>
        <Row align="middle" gutter={12}>
          <Col span={2}>
            <label>Version</label>
          </Col>
          <Col span={18}>
            <Select
              mode={'multiple'}
              value={versions}
              onChange={(vals) => setVersions(vals)}
              placeholder="Please select the addon"
              style={{ width: '80%' }}
            >
              {fileContent?.versions?.map((version) => (
                <Option key={version.version} value={version.version}>
                  {version.version}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
        <div style={{ flex: 1, minHeight: 100 }}>
          <label style={{ marginRight: 16 }}>Definition</label>
          <TextArea
            value={fileContent != null ? JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)}, null, 2) : ""}
            placeholder="Addon Preview"
            readOnly
            style={{
              height: '100%',
              resize: 'none',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap'
            }}
          />
        </div>
      </Modal>
    </>
  );
};